export enum EIoUrls {
  IO = 'io',
  TRANSACTIONS = 'transactions',
  DOCUMENTS = 'documents',
  UPLOAD = 'upload',
  'STORAGE' = 'storage',
}
